import React, { PureComponent } from 'react';
import {
  Card,
  Nav,
  NavItem,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Row
} from 'reactstrap';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';
import { omit } from 'underscore';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

// ducks
import { fetch, MEMBER_TYPE_MAP } from '../../ducks/AgentSearch';

// components
import LoadError from '../../components/load-error/load-error';
import AgentCard from '../../partials/agent-card/agent-card';
import BrokerageCard from '../../partials/brokerage-card/brokerage-card';

// containers
import PropertySearch from '../PropertySearch/PropertySearch';

class AgentDetail extends PureComponent {
  render() {
    const {
      error,
      id,
      record,
      searchURI,
      detailURI,
      currentURI,
      isLoading,
      loaded,
      searchPropertyClass,
      detailPropertyClass
    } = this.props;
    const isLoaded = !isLoading && loaded === id;
    const memberType = record.get('memberType');
    const propertyClass = searchPropertyClass || detailPropertyClass;
    return (
      <Container className={styles.AgentDetail}>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/find-naples-agent">
              <BreadcrumbItem>
                <Link to="/find-naples-agent">
                  Find a {MEMBER_TYPE_MAP[memberType].label}
                </Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to={`/agent/${id}`}>
              <BreadcrumbItem>
                <Link to={`/agent/${id}`}>
                  {MEMBER_TYPE_MAP[memberType].label} {record.get('fullName')}
                </Link>
              </BreadcrumbItem>
            </LinkContainer>
            <Switch>
              <Route
                path="/agent/:id/listings"
                exact
                render={() => <BreadcrumbItem>Listings</BreadcrumbItem>}
              />
              <Route
                path="/agent/:id/listings/advanced"
                exact
                render={() => <BreadcrumbItem>Listings Advanced</BreadcrumbItem>}
              />
            </Switch>
          </Breadcrumb>
        </Row>
        <Route
          path="/agent/:id"
          render={() => (
            <Container className={`${BS.breadcrumb2}`}>
              <Row>
                <Nav horizontal="space-between" className={`${BS.mt0} ${BS.mb3}`}>
                  {searchURI && !detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={searchURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                  {detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={detailURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                </Nav>
              </Row>
            </Container>
          )}
        />
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        <Card
          className={cx(styles.card, BS.h100, {
            [BS.dNone]: !isLoaded
          })}
        >
          <Row>
            <Col xs={12} md={5} className={`${BS.mb3} ${BS.dFlex}`}>
              <AgentCard
                tag="div"
                data={record.toJS()}
                imageAlign="left"
                className={BS.border0}
                detailURI={currentURI}
                hideOffice
                label={this.getAgentLabel()}
                propertyClass={propertyClass}
              />
            </Col>
            <Col xs={12} md={7} className={`${BS.mb3} ${BS.dFlex} ${BS.pt3}`}>
              <Route path="/agent/:id/listings">
                {props =>
                  props.match ? (
                    <BrokerageCard
                      tag="div"
                      data={record.get('office').toJS()}
                      className={`${BS.border0} ${BS.p0}`}
                      detailURI={currentURI}
                    />
                  ) : (
                    <div className={`${BS.pl3} ${BS.pr3} ${styles.agentDescription}`}>
                      About the {this.getFullAgentLabel()}:
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            record.getIn(['extended', 'content']) ||
                            "I'm currently in the process of updating my profile. Should you like to contact me, please use my contact information at the left and I will be happy to assist you with your real estate needs."
                          // Your search for paradise ends in Naples, Florida, with miles of beautiful sandy beaches and over 260 days of sunshine per year. Naples offers world class golfing and tennis for the sports lover in the family. Browse our list of <a href="golf-results.asp">Naples Golf Courses</a>.<br><br><a href="find-naples-home.asp">Homes For Sale in Naples</a> range from beautifully constructed old Florida single level homes to luxurious high rises on the beach. Start your search for your dream home in Naples right here at Naplesarea.com.<br><br>You can also browse our extensive list of <a href="community-results.asp">Naples Communities</a> and find the one that suits your Naples lifestyle. And find the best reference for <a href="naples-collier-county-schools.asp">Naples Schools</a>.<br><br>Let the experienced professionals of the <a href="find-naples-realtor.asp">Naples Board of REALTORS®</a> help you find your perfect Naples home. Whether you are buying a home in Naples or have a property for sale, members of the Naples Board of REALTORS®&nbsp;can help you navigate your next real estate transaction.<br><br>Please take a look at <a href="naples-collier-demographics.asp">Naples Demographics</a>, <a href="poi-results.asp">Points of Interest</a>, and <a href="real-estate-news.asp">Naples Real Estate Market Statistics</a>.
                        }}
                      />
                    </div>
                  )
                }
              </Route>
            </Col>
          </Row>
          <hr className={`${BS.btDashed} ${BS.ml3} ${BS.mr3}`} />
          <Switch>
            <Route
              path="/agent/:id/listings"
              render={() => (
                <PropertySearch
                  className={BS.flex1}
                  agentId={record.get('id')}
                  hideBreadcrumb
                  pathname={`/agent/${id}/listings`}
                  pathnameAdvanced={`/agent/${id}/listings/advanced`}
                  pathnameAdvancedResults={`/agent/${id}/listings/advanced/results`}
                  query={this.props.query}
                />
              )}
            />
            <Route
              path="/agent/:id"
              render={() =>
                isLoaded && (
                  <Row>
                    <Col xs={12} md={5} className={`${BS.mb3} ${BS.dFlex}`}>
                      <BrokerageCard
                        tag="div"
                        data={record.get('office').toJS()}
                        className={`${BS.border0} ${BS.pt0}`}
                        detailURI={currentURI}
                      />
                    </Col>
                    <Col xs={12} md={7} className={`${BS.mb3} ${BS.dFlex}`}>
                      <div className={cx(styles.brokerDescription, BS.pl3, BS.pr3)}>
                        About the Office:
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              record.getIn(['office', 'extended', 'content']) ||
                              "We are currently in the process of updating our firm's profile. Should you like to contact us, please use our contact information at the left and we will be happy to assist you with your real estate needs."
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )
              }
            />
          </Switch>
        </Card>
      </Container>
    );
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id });
    }
  }

  reload() {
    const { load, id } = this.props;

    if (load && id) {
      load({ id });
    }
  }

  getAgentLabel() {
    const { record } = this.props;
    const memberType = record.get('memberType');
    var label = 'Agent';

    if (memberType === 'service_provider') {
      label = 'Provider';
    }

    return label;
  }

  getFullAgentLabel() {
    const { record } = this.props;
    const memberType = record.get('memberType');
    var label = 'Agent';

    if (memberType === 'service_provider') {
      label = 'Service Provider';
    }

    return label;
  }
}

export default connect(
  (state, props) => {
    const id = props.match.params.id;
    const { searchURI, detailURI, ...query } = URI(state.routing.location.search).search(
      true
    );
    const { pathname, search = {} } = state.routing.location;

    return {
      id,
      record: state.AgentSearch.getIn(['detail', 'record']),
      isLoading: state.AgentSearch.getIn(['detail', 'loading']),
      loaded: state.AgentSearch.getIn(['detail', 'loaded']),
      error: state.AgentSearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-naples-agent',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI:
        pathname &&
        URI(pathname).search(omit(search, 'detailURI', 'searchURI')).toString(),
      searchPropertyClass: searchURI
        ? URI(searchURI).search(true).propertyClass
        : undefined,
      detailPropertyClass: detailURI
        ? URI(detailURI).search(true).propertyClass
        : undefined,
      query
    };
  },
  { load: fetch }
)(AgentDetail);



// WEBPACK FOOTER //
// ./src/containers/AgentDetail/AgentDetail.js